import { useState, useCallback } from 'react';
import SEO from '../../components/SEO';
import AdUnit from '../../components/AdUnit';

function toTitleCase(s) { return s.replace(/\w\S*/g, function (t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }); }
function toSentenceCase(s) { return s.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, function (c) { return c.toUpperCase(); }); }
function toAlternating(s) { var r = ''; for (var i = 0; i < s.length; i++) { r += i % 2 === 0 ? s[i].toLowerCase() : s[i].toUpperCase(); } return r; }
function toSlug(s) { return s.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_]+/g, '-').replace(/^-+|-+$/g, ''); }

function CaseConverter() {
  const [text, setText] = useState('');
  const [copied, setCopied] = useState('');

  var convert = useCallback(function (type) {
    var result = text;
    switch (type) {
      case 'upper': result = text.toUpperCase(); break;
      case 'lower': result = text.toLowerCase(); break;
      case 'title': result = toTitleCase(text); break;
      case 'sentence': result = toSentenceCase(text); break;
      case 'alternating': result = toAlternating(text); break;
      case 'slug': result = toSlug(text); break;
      default: break;
    }
    setText(result);
  }, [text]);

  var copy = useCallback(function () {
    if (!text) return;
    navigator.clipboard.writeText(text).then(function () {
      setCopied('yes'); setTimeout(function () { setCopied(''); }, 2000);
    });
  }, [text]);

  var buttons = [
    { key: 'upper', label: 'UPPERCASE' },
    { key: 'lower', label: 'lowercase' },
    { key: 'title', label: 'Title Case' },
    { key: 'sentence', label: 'Sentence case' },
    { key: 'alternating', label: 'aLtErNaTiNg' },
    { key: 'slug', label: 'url-slug' },
  ];

  return (
    <div className="page-prettifier">
      <SEO title="Case Converter - Change Text Case Online" description="Free online case converter. Transform text to UPPERCASE, lowercase, Title Case, Sentence case, and more with one click." path="/case-converter" />
      <div className="container">
        <div className="tool-header">
          <h1>Case Converter</h1>
          <p>Type or paste your text, then click a button to change its case instantly.</p>
        </div>
        <AdUnit />
        <div className="case-buttons">
          {buttons.map(function (b) {
            return <button key={b.key} onClick={function () { convert(b.key); }} className="btn btn-secondary" type="button">{b.label}</button>;
          })}
          <button onClick={copy} className="btn btn-primary" type="button" disabled={!text}>{copied ? '✓ Copied' : 'Copy'}</button>
          <button onClick={function () { setText(''); }} className="btn btn-secondary" type="button">Clear</button>
        </div>
        <div className="editor-pane" style={{ marginTop: '1rem' }}>
          <div className="pane-header"><span>Your Text</span><span className="char-count">{text.length} chars</span></div>
          <textarea className="editor-textarea" value={text} onChange={function (e) { setText(e.target.value); }} placeholder="Type or paste your text here..." spellCheck={false} aria-label="Text input" style={{ minHeight: '300px' }} />
        </div>
        <section className="tool-guide">
          <h2>When Do You Need Case Conversion?</h2>
          <p>Case conversion is useful in many everyday situations: fixing text that was accidentally typed in caps lock, formatting titles for documents or presentations, creating URL-friendly slugs for websites, standardizing data in spreadsheets, or preparing text for social media posts. This tool handles all of these in one place.</p>
        </section>
      </div>
    </div>
  );
}

export default CaseConverter;
